import { usePermissionContext, useWorkspaceContext } from '../context';

export const enum LeadAccess {
  VIEW_LEAD_LISTING_ALL = 'VIEW_LEAD_LISTING_ALL',
  VIEW_LEAD_DETAILS = 'VIEW_LEAD_DETAILS',
  ADD_LEAD_DETAILS = 'ADD_LEAD_DETAILS',
  EDIT_LEAD_DETAILS = 'EDIT_LEAD_DETAILS',
}

export const useLeadAuthz = (action: LeadAccess) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();

  return (
    workspace.owns ||
    (workspace.role &&
      permissionContext.isAuthorized &&
      permissionContext.isAuthorized('LEAD', action, [workspace.role]))
  );
};
